import { useEffect } from 'react';
import { useConfigAtomUpdate } from '../state';
import useDeepCompareEffect from './useDeepCompareEffect';
import useResetState from './useResetState';
export default function useCompatible(props) {
  var reset = useResetState();
  var updateConfigAtom = useConfigAtomUpdate();
  useEffect(function () {
    return function () {
      // eslint-disable-next-line no-console
      console.log('------------ 执行重置 ------------');
      reset({
        all: true
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // 兼容2.0以下版本通过props传递配置的写法
  useDeepCompareEffect(function () {
    updateConfigAtom(props);
  }, [props]);
}